__webpack_require__.p = "/live-score/";